import { FC } from "react";
import { Button, Typography } from "@kamstrup/kfl";
import { CenteredCard } from "../../containers/card";
import { commonStyles } from "../../styles/commonStyles";

interface ConfirmationStepProps {
  cardTitle: string;
  message: string;
  buttonText: string;
  onButtonClick: () => void;
}

export const ConfirmationStep: FC<ConfirmationStepProps> = ({
  cardTitle,
  message,
  buttonText,
  onButtonClick
}) => {
  return (
    <CenteredCard title={cardTitle}>
      <Typography variant="body4" sx={commonStyles.introText}>
        {message}
      </Typography>
      <Button
        color="primary"
        variant="contained"
        fullWidth
        sx={commonStyles.button}
        onClick={onButtonClick}
      >
        <Typography variant="body4">{buttonText}</Typography>
      </Button>
    </CenteredCard>
  );
};
